export const VIDEO_TIMESTAMP_CLASS = 'video-timestamp';

export const INLINE_COMMENT_LOOM_VIDEO_SELECTOR = 'a.external-link';
export const COMMENT_CONTAINER_CLASS = 'content-section';

export const CREATION_METHOD_TIMELINE = 'timeline';
export const CREATION_METHOD_COMMENT_OVERLAY = 'comment_overlay';
export const CREATION_METHOD_RECORD_REPLY = 'record_reply';
export const COMMENT_BUBBLE_TRANSITION_DURATION = 300;
